<template>
  <div class="view-content view8">
    <div class="left">
      <div class="title">{{ $t('商业闭环') }}</div>
      <div class="text text-padding">{{ $t('让消费、社交与收益形成价值闭环。') }}</div>
      <div class="label">{{ $t('全球分销体系让每个用户都能成为品牌的传播者与收益方。') }}</div>
    </div>
    <div class="right">
      <div class="view8-li" v-for="(item, index) in list" :key="index" :style="{transform: `translateY(${item.top})`}">
        <div class="view8-title">
            <img class="view8-img" :src="item.icon">
            <div class="view8-title-text">{{ item.title }}</div>
        </div>
        <div class="view8-text" :style="{minHeight: item.height}">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'view8',
  data () {
    return {
        list: [
            {
                icon: require('./img/1030/view8-1.png'),
                title: this.$t('消费者端'),
                text: this.$t('注册/消费即得积分奖励，积分每日释放为资产。'),
                height: "2.33rem",
                top: "0px",
            },
            {
                icon: require('./img/1030/view8-2.png'),
                title: this.$t('商家端'),
                text: this.$t('一键接入结算 API，设置折让比例与积分政策。'),
                height: "2.83rem",
                top: "65px",
            },
            {
                icon: require('./img/1030/view8-3.png'),
                title: this.$t('分销端'),
                text: this.$t('允许全球用户参与分销，共享收益与品牌成长。'),
                height: "3.48rem",
                top: "130px",
            },
        ]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
        // this.$nextTick(() => {
        //     setTimeout(() => {
        //         const bgImg = this.$refs.bgImg
        //         this.list = this.list.map(item => {
        //             console.log(item)
        //             if (item.heightNum !== '0') {
        //                 item.position = `-${bgImg.clientHeight - item.heightNum}px`
        //             }
        //             return item
        //         })
        //     }, 300)
        // })
    }
  }
}
</script>

<style scoped>
@import "./css/index.css";

.view8 .label {
    padding-top: 0;
}

.view8 .label {
    padding-right: 200px;
    color: #fff;
}

.view8 .left {
    transform: translateY(-150px);
}

.view8 .right {
    width: 40vw;
    display: flex;
    justify-content: flex-end;
}

.view8-li {
    margin-left: 20px;
    flex: 1;
    /* padding: 8px 24px; */
    gap: 4px;
    flex-shrink: 0;
    box-sizing: border-box;
}

.view8-title {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #07C160;
    padding: 20px 24px;
}

.view8-img {
    width: 26px;
    margin-right: 4px;
}

.view8-title-text {
    font-size: 24px;
    font-weight: 600;
}

.view8-text {
    padding: 36px 33px;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%);
}

@media screen and (max-width: 768px) {
    .view8 {
        justify-content: center;
    }
    .view8 .left {
        transform: translateY(0);
    }
    .view8 .right {
        width: 100%;
        display: block;
    }
    .view8-footer-list {
        position: relative;
        padding: 43px 0px 0px 0px;
        display: block;
    }
    .view8-li  {
        margin-left: 0;
        transform: translateY(0) !important;
        margin-bottom: 17px;
    }
    .view8-title {
        padding: 8px 0;
    }
    .view8-title-text {
        font-size: 18px;
    }
    .view8-img {
        width: 18px;
    }
    .view8-text {
        min-height: 100px !important;
        box-sizing: border-box;
        padding: 16px 24px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/lobby/components1030/view8.vue